"use client";
import React from "react";
import { CompareApiResponse, FundProsConsResult } from "@/type/comparePageTypes";
import { useLoginModal } from "@/utils/useLoginModal";
import { buildFundCards, matchOrderByIds } from "@/utils/comparePageFunctions";
import VerdictCard from "../cards/VerdictCard";

export default function BestPickFundsSection({ funds, schemeOrder, prosConsByFund }: { funds: CompareApiResponse; schemeOrder: number[]; prosConsByFund: FundProsConsResult[] }) {
  const { isLoggedIn } = useLoginModal();

  const fundCards = buildFundCards(funds, prosConsByFund, isLoggedIn);
  const result = matchOrderByIds(schemeOrder, fundCards);

  return (
    <div className="flex flex-col xs:flex-row flex-wrap items-center justify-center gap-6 relative">
      {result.map((card) => (
        <VerdictCard key={card.id} data={card} autoOpen={fundCards.length <= 1} />
      ))}
    </div>
  );
}
